import { render, staticRenderFns } from "./custom-form-date-picker.vue?vue&type=template&id=635a68fe&scoped=true"
import script from "./custom-form-date-picker.vue?vue&type=script&lang=js"
export * from "./custom-form-date-picker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635a68fe",
  null
  
)

export default component.exports